module.exports = __webpack_public_path__ + "media/ape.918c1c1c.mp4";